import * as React from "react";
import {
  PanelGroup as ResizablePrimitiveGroup,
  Panel as ResizablePrimitivePanel,
  PanelResizeHandle,
} from "react-resizable-panels";

import { cn } from "@/lib/utils";

const ResizablePanelGroup = React.forwardRef<
  React.ElementRef<typeof ResizablePrimitiveGroup>,
  React.ComponentPropsWithoutRef<typeof ResizablePrimitiveGroup>
>(({ className, ...props }, ref) => (
  <ResizablePrimitiveGroup
    ref={ref}
    className={cn("flex h-full w-full data-[panel-group-direction=vertical]:flex-col", className)}
    {...props}
  />
));
ResizablePanelGroup.displayName = "ResizablePanelGroup";

const ResizablePanel = React.forwardRef<
  React.ElementRef<typeof ResizablePrimitivePanel>,
  React.ComponentPropsWithoutRef<typeof ResizablePrimitivePanel>
>(({ className, ...props }, ref) => (
  <ResizablePrimitivePanel
    ref={ref}
    className={cn("flex min-h-[200px] min-w-[200px] flex-1 flex-col", className)}
    {...props}
  />
));
ResizablePanel.displayName = "ResizablePanel";

const ResizableHandle = React.forwardRef<
  React.ElementRef<typeof PanelResizeHandle>,
  React.ComponentPropsWithoutRef<typeof PanelResizeHandle> & {
    withHandle?: boolean;
  }
>(({ className, withHandle, ...props }, ref) => (
  <PanelResizeHandle
    ref={ref}
    className={cn(
      "flex w-px items-center justify-center bg-muted data-[panel-group-direction=vertical]:h-px data-[panel-group-direction=vertical]:w-full data-[panel-group-direction=vertical]:py-1 data-[panel-group-direction=vertical]:px-0 data-[panel-group-direction=horizontal]:px-1",
      className,
    )}
    {...props}
  >
    {withHandle && (
      <div className="z-10 flex h-6 w-6 items-center justify-center rounded-full border border-border bg-background shadow">
        <div className="h-4 w-0.5 rounded-full bg-muted" />
      </div>
    )}
  </PanelResizeHandle>
));
ResizableHandle.displayName = "ResizableHandle";

export { ResizablePanelGroup, ResizablePanel, ResizableHandle };
